import { isDefined } from "@clipboard-health/util-ts";
import { useEffect, useState } from "react";

/**
 * Returns whether the element is "stuck" at the top of the scroll container
 * (content has scrolled underneath it).
 */
export function useScrollOffset(
  scrollContainerElement: HTMLElement | undefined,
  elementRef: React.RefObject<HTMLDivElement>
) {
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollContainerElement;
    const element = elementRef.current;

    const updateStuckState = () => {
      if (!isDefined(scrollContainer) || !isDefined(element)) {
        return;
      }
      const containerRect = scrollContainer.getBoundingClientRect();
      const headerRect = element.getBoundingClientRect();
      // Header is stuck when its top is at or past the container's top (content scrolling underneath)
      setIsStuck(headerRect.top <= containerRect.top + 1);
    };

    if (isDefined(scrollContainer) && isDefined(element)) {
      scrollContainer.addEventListener("scroll", updateStuckState);
      updateStuckState(); // Initial measurement
    }

    return () => {
      if (isDefined(scrollContainer)) {
        scrollContainer.removeEventListener("scroll", updateStuckState);
      }
    };
  }, [scrollContainerElement, elementRef]);

  return { isStuck };
}
